import React, {useState} from "react";
import "./SideMenu.css";
import MenuOptions from "../../../Shared/Components/MenuOptions/MenuOptions";
import { sideMenu, sideMenuLabels, viewTutorialLinks, textSizeConstants, logoutConstants, sideMenuNeGD } from "../../../NewConstants/MenuConstants";
import { fontSizeLabel, languageLabel } from "../../../NewConstants/Language-Constants";
import { useNavigate } from "react-router-dom";
import LogoutDialog  from "../../../Shared/Components/LogoutDialog/LogoutDialog";
import { getDefaultLanguage, getMobileNumber, getUserCadre, setDefaultLanguage, setLanguageChangeFlag, trackEvent, isNeGDDeployment} from "../../../Actions/Utils";
const SideMenu = ({
  userData,
  toggleMenu = () => {},
  selectedLanguage,
  setSelectedLanguage = () => {},
  textSize,
  decreaseTextSize = () => {},
  increaseTextSize = () => {},
  toggleHelp = () => {}
}) => {
  const navigate = useNavigate();
  const hide_lang_button = process.env.REACT_APP_HIDE_LANG_BUTTON === 'true';
  const [openDialog, setOpenDialog] = useState(false);
  const styles = {
    nameText: {
      fontSize: `${textSize + 0.5}rem`,
    },
    infoText: {
      fontSize: `${textSize + 0.125}rem`,
    },
    readText: {
      fontSize: `${textSize - 0.25}rem`,
    },
  };
  const toggleLogout = () => {
    trackEvent("logout_initiated", "Click", "Number of times users clicked on logout button");
    setOpenDialog(true);
  };

  const handleClose = () => {
    trackEvent("logout_cancelled", "Click", "Number of times users cancelled logout ('No, I want to go back')");
    setOpenDialog(false);
  };

  const handleConfirmLogout = () => {
    trackEvent("logout_confirmed", "Click", "Number of times users confirmed logout ('Yes I want to logout')");
    const lang = getDefaultLanguage();
    sessionStorage.clear();
    localStorage.clear();
    setDefaultLanguage(lang);
    navigate("/login");

    // Implement your logout logic here
    setOpenDialog(false);
  };

  const menuItemClickFun = (menuItem) => {
    if (menuItem === sideMenuLabels.ViewTutorial) {
      window.open(viewTutorialLinks[selectedLanguage], "_blank")
    }
    if (menuItem === sideMenuLabels.HelpAndFeedback) {
      trackEvent("feedback_submitted", "Click", "Number of times users clicked on feedback button");
      toggleMenu()
      toggleHelp()
    }
    if (menuItem === sideMenuLabels.ChangeLanguage) {
      trackEvent("language_changed", "Click", "Number of times users clicked on language selection button");
      setLanguageChangeFlag("false");
      navigate("/lang")
    }
  }

  // const handleLogout = () => {
  //   sessionStorage.clear();
  //   localStorage.clear();
  //   navigate("/");
  // };
  return (
    <div className="outer-container">
      <div className="overlay"></div>
      <div className="inner-container">
        {isNeGDDeployment() ? (
          <div className="flex justify-end items-center pr-6 pt-4">
            <div onClick={toggleMenu} className="bg-[var(--red-5)] rounded-full p-2">
                <img src="/Assets/Images/ArrowLeftRed.svg" alt="close" />
              </div>
          </div>
        ):(
          <div className="px-6 py-4 userDiv">
            <div className="flex justify-between items-center">
              <div
                className={`font-semibold text-[color:var(--black)]`}
                style={styles.nameText}
              >
                {userData?.name}
              </div>
              <div onClick={toggleMenu}>
                <img src="/Assets/Images/close.svg" alt="close" />
              </div>
            </div>
            <div
              className={`font-normal text-[color:var(--black)] opacity-50`}
              style={styles.infoText}
            >
              {getUserCadre()} <br />
              {getMobileNumber()} <br />
              {userData?.location?.district[selectedLanguage]}, {userData?.location?.state[selectedLanguage]}
            </div>
          </div>
        )}
        {isNeGDDeployment() ? sideMenuNeGD.map((itm, idx) => (
          <MenuOptions
            id={itm.id}
            key={idx}
            value={itm.value[languageLabel[selectedLanguage]]}
            icon={itm.icon}
            textSize={textSize}
            clickFun={menuItemClickFun}
          />
        )) : sideMenu.map((itm, idx) => (
          <MenuOptions
            id={itm.id}
            key={idx}
            value={itm.value[languageLabel[selectedLanguage]]}
            icon={itm.icon}
            textSize={textSize}
            clickFun={menuItemClickFun}
          />
        ))}
        <div className="bottomSectionDiv">
          <div className="px-8">
            <div className="text-[color:var(--dark-neutral-2)] text-sm">
              {textSizeConstants[selectedLanguage]}
            </div>
            <div className="changeSizeBtnDiv">
              <button
                onClick={(e) => decreaseTextSize(e)}
                className={
                  textSize === 0.875 ? "pointer-events-none opacity-30" : ""
                }
              >
                {fontSizeLabel[selectedLanguage]}-
              </button>
              <div className="h-[100%] bg-[var(--light-neutral-3)] w-px" />
              <button
                onClick={(e) => increaseTextSize(e)}
                className={
                  textSize === 1.125
                    ? "pointer-events-none opacity-30 font-medium text-lg"
                    : "font-medium text-lg"
                }
              >
                {fontSizeLabel[selectedLanguage]}+
              </button>
            </div>
          </div>
        {isNeGDDeployment() ? (
            <div className="h-[2.125rem] bg-[var(--light-neutral-13)]">
              
            </div>
          ):(
          <div className="bg-[var(--light-neutral-6)]">
            <div className="px-8 py-4">
              {/* <div
                className={`flex gap-3 text-[color:var(--red-button)] pb-4 items-center`}
                style={styles.infoText}
              >
                <img
                  src={"/Assets/Images/withdrawIcn.svg"}
                  alt="withdraw consent"
                />
                {selectedLanguage === "en"
                  ? "Withdraw consent"
                  : "सहमति वापस लें"}
              </div> */}
              {/* <button
                className={`flex gap-3 text-[color:var(--red-button)] py-4 items-center`}
                style={styles.infoText}
                onClick={handleConfirmLogout}
              >
                <img src={"/Assets/Images/logoutIcn.svg"} alt="logout" />
                {selectedLanguage === "en" ? "Withdraw Consent" : "सहमति वापस लें"}
              </button> */}

              <button
                className={`flex gap-3 text-[color:var(--red-button)] py-4 items-center`}
                style={styles.infoText}
                onClick={toggleLogout}
              >
                <img src={"/Assets/Images/logoutIcn.svg"} alt="logout" />
                {logoutConstants[selectedLanguage]}
              </button>
              <LogoutDialog
                open={openDialog}
                handleClose={handleClose}
                handleConfirm={handleConfirmLogout}
                message="Are you sure you want to log out?"
                selectedLanguage= {selectedLanguage}
                textSize={textSize}
              />

              {/* <div className={`opacity-60 py-1`} style={styles.readText}>
                Read more about{" "}
                <span className="text-[var(--link-color)] underline">
                  {appVersionConstants.appName}
                </span>
                <br />
                Version {appVersionConstants.version} released on {appVersionConstants.realease_date}
              </div> */}
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideMenu;
